/**
 * Created by andrey on 20.05.2022.
 */

const BankView = cc.Node.extend({
    ctor: function (bank, unitView) {
        this._super();

        this.bank = bank;
        this.unitView = unitView;

        this.restoreState();
    },

    restoreState: function (animated) {
        if (animated && this.bank.state === Bank.STATES.READY && !this.adsIcon) {
            cleverapps.effects.fire("bank.ready");
        }

        if (animated && this.bank.state === Bank.STATES.WATCHED) {
            cleverapps.effects.fire("bank.collect");
        }

        if (this.bank.isAdsIconVisible()) {
            this.createAdsIcon(animated);
        } else {
            this.removeAdsIcon(animated);
        }

        if (this.bank.isTimerVisible()) {
            this.createTimer(animated);
        } else {
            this.removeTimer(animated);
        }
    },

    createAdsIcon: function (animated) {
        if (this.adsIcon) {
            this.updateAdsIcon();
            return;
        }

        const styles = cleverapps.styles.BankView.ads;

        const adsIcon = this.adsIcon = new cleverapps.Spine(bundles.bank.jsons.bank_ads_icon);
        adsIcon.setAnimation(0, "idle", true);
        adsIcon.setAlignment(styles);
        this.unitView.sprite.addChild(adsIcon);

        cleverapps.UI.onClick(adsIcon, this.unitView.handleClick.bind(this.unitView));

        this.updateAdsIcon();

        if (animated && this.bank.state === Bank.STATES.READY) {
            adsIcon.setAnimationAndIdleAfter("animation", "idle");
            adsIcon.setScale(0);
            adsIcon.runAction(new cc.ScaleTo(0.3, 1).easing(cc.easeIn(2)));
        }
    },

    updateAdsIcon: function () {
        cleverapps.UI.convertToGrayScale(this.adsIcon, this.bank.state === Bank.STATES.READY);
    },

    removeAdsIcon: function (animated) {
        if (!this.adsIcon) {
            return;
        }

        if (!animated) {
            this.adsIcon.removeFromParent();
            return;
        }

        this.adsIcon.runAction(new cc.Sequence(
            new cc.ScaleTo(0.1, 0.3).easing(cc.easeIn(2)),
            new cc.Hide()
        ));
        this.adsIcon = undefined;
    },

    createTimer: function (animated) {
        let timer = this.unitView.getAdditionalView("timer");
        if (timer) {
            timer.view.countDown.resetTimeLeft(this.bank.getTimeLeft());
            return;
        }

        const styles = cleverapps.styles.BankView.timer;

        const countdown = new cleverapps.CountDownView(new cleverapps.CountDown(this.bank.getTimeLeft()), {
            font: cleverapps.styles.FONTS.COMPONENT_TIMER_TEXT,
            background: {
                frame: bundles.small_timer_merge.frames.timer_bg_png,
                width: styles.width,
                height: styles.height
            },
            icon: {
                frame: bundles.small_timer_merge.frames.timer_png,
                json: bundles.small_timer.jsons.small_timer_json,
                animation: "animation"
            }
        });
        countdown.setAlignment(styles);
        this.unitView.createAdditionalView("timer", countdown);

        if (animated) {
            timer = this.unitView.getAdditionalView("timer");
            timer.animateAppear();
        }
    },

    removeTimer: function (animated) {
        this.unitView.removeAdditionalView("timer", !animated);
    }
});

cleverapps.styles.BankView = {
    ads: {
        x: { align: "center", dx: 37 },
        y: { align: "center", dy: -42 }
    },

    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -55 },
        width: 135,
        height: 29
    }
};
